import React, { useState } from 'react';
import '../../App.css';

const Register = () => {
  const [formData, setFormData] = useState({
    username: '', mobile: '', email: '', password: '', 
    confirmPassword: '', hospitalName: '', logo: null
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({ ...formData, [name]: files ? files[0] : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Logic for Multipart Form Data (using FormData for Logo)
    console.log("Submitting:", formData);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Create Account</h2>
        <span className="brand-name">eMedha Hospital Management</span>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Hospital Name</label>
            <input type="text" name="hospitalName" placeholder="Elite Wellness Center" onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Hospital Logo</label>
            <div className="file-input-wrapper">
              <input type="file" name="logo" accept="image/*" onChange={handleChange} />
            </div>
          </div>
          <div className="form-group">
            <label>Username</label>
            <input type="text" name="username" onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Email Address</label>
            <input type="email" name="email" onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" name="password" onChange={handleChange} required />
          </div>
          <button type="submit" className="btn-primary">Register Hospital</button>
        </form>
      </div>
    </div>
  );
};

export default Register;